import { ChartMarkerInterface } from '../../chart/candlestick-chart.component';
import { SignalInterface } from '../../../ng-services/social-trading/signal-sharing.store';

export class SignalSharingCandlestickComponent {
    signal!: SignalInterface;
    marker!: ChartMarkerInterface;

    $onInit() {
        this.marker = {
            name: this.signal.signal_name,
            color: this.signal.color,
            date: new Date(this.signal.timestamp),
        };
    }
}

angular.module('tradersyard').component('tySignalSharingCandlestick', {
    // language=HTML
    template: `
        <ty-candlestick-chart symbol="$ctrl.signal.symbol" marker="$ctrl.marker"/>
    `,
    controller: SignalSharingCandlestickComponent,
    bindings: {
        signal: '<',
    },
});
